import { UsersState } from '@pages/access-groups/store/states/users.state';
import { ProductsState } from '@pages/access-groups/store/states/products.state';
import { CategoriesState } from '@pages/access-groups/store/states/categories.state';
import { AccessGroupState } from '@pages/access-groups/store/states/access-group.state';
import { AccessGroupsState } from '@pages/access-groups/store/states/access-groups.state';

export const accessGroupsState = [AccessGroupsState, UsersState, ProductsState, CategoriesState, AccessGroupState];
